/**
 * ROOT e ADMIN veem tudo. MEMBER vê só as abas liberadas em `User.tabs`.
 * AGENT, EDITOR e SERVICE_MANAGER são os cargos antigos: todos viraram MEMBER (29/10/2026)
 * e não se atribuem mais; ficam aqui só porque a API ainda pode devolvê-los.
 */
export enum UserRole {
  ROOT = 'ROOT',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  AGENT = 'AGENT',
  EDITOR = 'EDITOR',
  SERVICE_MANAGER = 'SERVICE_MANAGER',
}

/** O que se escolhe no cadastro: Administrador ou Membro. */
export type AccessType = UserRole.ADMIN | UserRole.MEMBER;

export interface User {
  id: number;
  name: string;
  email: string;
  role: UserRole;
  blocked: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt?: string;
  /** Abas do portal liberadas para o membro (rotas do menu). Vazio para administrador. */
  tabs?: string[];
}

export interface CreateUserDto {
  name: string;
  email: string;
  role: AccessType;
  /** Só para membro: as abas liberadas. */
  tabs?: string[];
}

export interface UpdateUserDto {
  name?: string;
  email?: string;
}

export interface UpdateUserRoleDto {
  role: AccessType;
  /** Só para membro: as abas liberadas (substitui as que ele tinha). */
  tabs?: string[];
}
